import script from "./StatusDuration.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusDuration.vue?vue&type=script&setup=true&lang=js"

import "./StatusDuration.vue?vue&type=style&index=0&id=52bf18a8&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52bf18a8"]])

export default __exports__